module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_vm._l((4), function(n, i) {
    return [_c('v-flex', {
      key: i,
      class: _vm.fotos[n - 1] !== undefined ? 'text-xs-center pa-2 outerDiv' : 'text-xs-center pa-2 outerDiv',
      attrs: {
        "md3": ""
      }
    }, [(_vm.fotos[n - 1] !== undefined) ? _c('div', {
      staticClass: "outerDiv"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.fotos[n - 1],
        "alt": ""
      }
    })]) : [_c('input', {
      staticClass: "invisible-all",
      attrs: {
        "type": "file",
        "name": "",
        "value": ""
      },
      on: {
        "change": _vm.adicionarFoto
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "outerDiv"
    }, [_c('div', {
      staticClass: "pa-2 noselect foto"
    }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n              adicionar foto\n            ")], 1)])]], 2)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34198a99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/Galeria.vue
// module id = 744
// module chunks = 2